export default "__VITE_ASSET__B8EZOcm7__"